// Carry Roll ExportPanel — CSV/PDF export + shareable report (11.5, 11.6).

import { useStore } from '../../store';
import { useResult } from '../../store/selectors';
import { shotsToCsv, downloadCsv } from '../../export/csv';
import { exportYardageCardPdf } from '../../export/pdf';
import { downloadTextReport } from '../../export/shareReport';

export function ExportPanel() {
  const result = useResult();
  const sessions = useStore((s) => s.sessions);
  const distanceUnit = useStore((s) => s.distanceUnit);

  const handleCsv = () => {
    const allShots = sessions.flatMap((s) => s.shots);
    if (allShots.length === 0) {
      downloadCsv('carry-roll-shot.csv', shotsToCsv([
        {
          id: 'current',
          request: useStore.getState().request,
          carryM: result.carryM,
          totalM: result.totalM,
          excluded: false,
        },
      ]));
    } else {
      downloadCsv('carry-roll-sessions.csv', shotsToCsv(allShots));
    }
  };

  const handlePdf = () => {
    exportYardageCardPdf(useStore.getState().bag, 'Carry Roll Yardage Card', distanceUnit);
  };

  const handleReport = () => {
    downloadTextReport(result);
  };

  return (
    <div data-testid="export-panel">
      <h3 className="subsection-title">
        Data &amp; export
      </h3>
      <div className="flex gap-2 flex-wrap">
        <button type="button" className="btn" onClick={handleCsv}>
          Export CSV
        </button>
        <button type="button" className="btn" onClick={handlePdf}>
          Yardage card PDF
        </button>
        <button type="button" className="btn" onClick={handleReport}>
          Share report
        </button>
      </div>
    </div>
  );
}
